export default {
	zh: {
		// 页面分享
		让世界上每一个有可能的地方都变成家: "让世界上每一个有可能的地方都变成家！",
		Wellcee的小伙伴们分享了好多有趣的故事和瞬间呢: "Wellcee的小伙伴们分享了好多有趣的故事和瞬间呢！",
		// 评论
		评论: "评论",
		发表你的天才演讲: "发表你的天才演讲",
		作者: "作者",
		回复: "回复",
		加载中: "加载中...",
		// lifestyle列表
		城市: "城市",
		推荐: "推荐",
		不限: "不限",
		// 个人中心
		TA的房源: "TA的房源",
		TA的唯心市集: "TA的唯心市集",
		TA的Lifestyle: "TA的Lifestyle",
		TA的动态: "TA的动态",
		查看更多: "查看更多",
		私信: "私信",
		// 房源列表
		位置: "位置",
		租房类型: "租房类型",
		价格: "价格",
		区域: "区域",
		地铁: "地铁",
		租期: "租期",
		确定: "确定",
		最后登录: "最后登录",
		全部: "全部",
		// 房源详情
		详情: "详情",
		概况: "概况",
		已出租: "已出租",
		租金: "租金",
		月: "月",
		类型: "类型",
		房间: "房间",
		卧室: "卧室",
		洗手间: "洗手间",
		押金: "押金",
		面积: "面积",
		楼层: "楼层",
		描述: "描述",
		设施: "设施",
		地图: "地图",
		线上签约: "线上签约",
		// 首页
		搜索房源: "搜索房源",
		即将开放: "即将开放",
		唯心市集: "唯心市集",
		发现更多: "发现更多",
		探索: "探索",
		体验: "体验",
		打开APP: "打开APP",
		选择城市: "选择城市",
		// 下载页
		一个有灵魂的租房平台: "一个有灵魂的租房平台",
		无中介国际化社交: "无中介｜国际化｜社交",
		立即打开: "立即打开",
		立即下载: "立即下载",

		// 商务合作
		商务合作: "商务合作",
		请选择: "请选择",
		合作类型: "合作类型",
		姓名: "姓名",
		你的称呼: "你的称呼",
		联系方式: "联系方式",
		手机号微信号: "手机号/微信号",
		公司名称: "公司",
		请输入: "请输入",
		希望开展合作的城市: "希望开展合作的城市",
		备注: "备注",
		选填: "（选填）",
		提交: "提交",
		公寓商户: "公寓商户",
		优质民宿: "优质民宿",
		异业合作: "异业合作",
		广告推广: "广告推广",
		其他: "其他",
		公寓商户介绍: "包含公寓、二房东、包租公司、城中村大业主等",
		提交成功: "提交成功",
		请填写完整信息: "请填写完整信息",

		// 收不到验证码
		'no_auth_code.title': "收不到验证码",
		'no_auth_code.header': "如果您的手机无法正常获取验证码，建议您进行以下操作：",
		'no_auth_code.step1': "检查并确认您的手机号是否停机/无网络。",
		'no_auth_code.step2': "检查您的验证码是否被拦截/移至垃圾箱。",
		'no_auth_code.step3': "如进行以上操作后仍无法收到验证码，请发邮件联系我们：",
		'no_auth_code.step4': " 并附加您的个人信息。",
		'no_auth_code.card.title': "示例：",
		'no_auth_code.card.item1': "标题：手机号无法收取验证码",
		'no_auth_code.card.item2': "账户昵称：Max",
		'no_auth_code.card.item3': "手机号：+86 130****3465（添加您的国家区号）",
		'no_auth_code.card.item4': '邮箱：',
		'no_auth_code.card.item5': "性别：女",
		'no_auth_code.footer': "收到您的邮件后，我们会协助您处理账号相关问题。",

		// 手机号停机
		'phone_stop.title': "手机号停机",
		'phone_stop.header': "如果您的手机号已停机，无法登录账号，请通过邮箱联系我们并附加个人信息：",
		'phone_stop.card.title': "示例：",
		'phone_stop.card.item1': "标题：手机号停机无法登录",
		'phone_stop.card.item2': "账号昵称：Maxim",
		'phone_stop.card.item3': "账号绑定手机号：+86 130****3465",
		'phone_stop.card.item4': "新手机号：+86 183****1098",
		'phone_stop.card.item5': "城市：北京",
		'phone_stop.footer': "收到您的邮件后，我们会协助您找回账号。",

		// 优惠券规则
		'coupon_rule.title': '优惠券通用规则',

		// 线上签约合同详情页
		'sign_contract.detail1': '合同确认',
		'sign_contract.detail2': '查看合同',
		'sign_contract.detail3': '提示：签约完成后可查看隐藏信息（实名、联系方式等带*的信息）',
		'sign_contract.detail4': 'Wellcee · 线上租赁合同',
		'sign_contract.detail5': '本合同由以下三方共同确认生效：',
		'sign_contract.detail6': '出租方（甲方）：',
		'sign_contract.detail7': '承租方（乙方）：',
		'sign_contract.detail8': '证件号：',
		'sign_contract.detail9': '联系方式：',
		'sign_contract.detail10': '平台方（丙方）：上海良孝科技有限公司（Wellcee）',
		'sign_contract.detail11': '甲方与乙方通过 Wellcee 平台达成租赁意向，并自愿采用线上方式签署本合同。双方确认：本合同经线上确认后，与线下手写签名或盖章具备同等法律效力。',
		'sign_contract.detail12': '第一条 房屋信息与租赁期限',
		'sign_contract.detail13': '房屋详细地址：',
		'sign_contract.detail14': '租赁期限：自',
		'sign_contract.detail15': ' 起至 ',
		'sign_contract.detail16': ' 止。',
		'sign_contract.detail17': '第二条 租金与支付方式',
		'sign_contract.detail18': '双方确认 月租金为人民币 ',
		'sign_contract.detail19': ' 元/月（不含水电气费、物业费及其他杂费）。',
		'sign_contract.detail20': '租金由乙方根据事先和房东的约定按 ',
		'sign_contract.detail21': '月度',
		'sign_contract.detail22': '季度',
		'sign_contract.detail23': '年度',
		'sign_contract.detail24': ' 支付。逾期可能影响合同继续履行，由责任方承担后果。',
		'sign_contract.detail25': '维修费、物业费及其他费用的承担方式，以甲、乙双方协议为准。',
		'sign_contract.detail26': '第三条 押金托管规则',
		'sign_contract.detail27': '押金托管',
		'sign_contract.detail28': '乙方签约时需支付押金人民币 ',
		'sign_contract.detail29': ' 元，由 Wellcee 平台进行阶段性托管；平台仅提供技术托管，不承担押金责任认定。',
		'sign_contract.detail30': '押金可提现时间',
		'sign_contract.detail31': '乙方入住满 15 天后，甲方可在平台申请提取押金。入住 15 天内押金作为纠纷保障，未经双方确认不予提前提取。',
		'sign_contract.detail32': '押金依据资料',
		'sign_contract.detail33': '入住 15 天内的押金纠纷，以以下资料为依据：入住时的房屋现状照片、补充协议、平台聊天记录等（资料缺失或模糊，将影响相关协调支持。）',
		'sign_contract.detail34': '争议处理',
		'sign_contract.detail35': '若双方对押金金额有异议，平台可协助沟通，但平台',
		'sign_contract.detail36': '不对损坏责任或扣款合理性作出判断；',
		'sign_contract.detail37': '协商不成的，双方可通过房屋所在地法院或仲裁机构解决。',
		'sign_contract.detail38': '第四条 甲方（出租方）义务',
		'sign_contract.detail39': '保证房屋具备合法出租权，不存在查封、抵押、腾退风险。',
		'sign_contract.detail40': '保证房屋状况与租房信息一致；如存在虚假描述，乙方可解除合同，甲方需退还所有费用。',
		'sign_contract.detail41': '自然损耗或设备质量问题由甲方负责维修。',
		'sign_contract.detail42': '不得在租期内无正当理由提前收回房屋.',
		'sign_contract.detail43': '需按约定时间交付可正常居住的房屋。',
		'sign_contract.detail44': '第五条 乙方（承租方）义务',
		'sign_contract.detail45': '按时支付租金，遵守正常居住使用范围。',
		'sign_contract.detail46': '因乙方人为原因导致的设施损坏，需承担维修或赔偿费用。',
		'sign_contract.detail47': '不得擅自转租、群租、改变房屋用途或存放危险品。',
		'sign_contract.detail48': '需遵守小区物业管理规定，文明居住.',
		// 'sign_contract.detail49': '退租前需按平台要求上传完整退房照片。',
		'sign_contract.detail50': '第六条 身份验证与风控要求',
		'sign_contract.detail51': '大陆用户需完成人脸识别；港澳台及外国用户需上传证件照及手持证件照。',
		'sign_contract.detail52': '若任一方提交虚假资料、冒用他人身份，平台有权终止合同流程，合同自动失效，由责任方承担全部后果。',
		'sign_contract.detail53': '平台进行的是 技术性校验，不构成对身份真实性的法律鉴定。',
		'sign_contract.detail54': '第七条 合同附件与补充协议',
		'sign_contract.detail55': '房源出租方（甲方）可上传的附件，包括但不限于：补充协议、房屋现状照片、家具电器清单、交割清单、入住须知等。',
		'sign_contract.detail56': '所有上传附件均视为本合同组成部分，与本合同具有同等效力。',
		'sign_contract.detail57': '若附件内容与主合同冲突，以双方确认的最新附件为准。',
		'sign_contract.detail58': '第八条 提前终止合同',
		'sign_contract.detail59': '乙方提前退租：',
		'sign_contract.detail60': '乙方提前退租应至少提前 30 日通知甲方。',
		'sign_contract.detail61': '若双方无特别约定，乙方提前退租，甲方可要求乙方支付 不超过 1 个月租金 的补偿。',
		'sign_contract.detail62': '若因房屋质量问题、安全隐患、房源不符、甲方未按约交付可居住房屋等原因导致乙方无法入住，乙方可无责解除合同，甲方应退还乙方已支付的全部款项。',
		'sign_contract.detail63': '乙方因个人原因在入住日前取消已确认订单的，视为单方违约。甲方可向乙方收取"违约金"，其计算方式为：',
		// 'sign_contract.detail64': '锁房天数：',
		// 'sign_contract.detail65': '自合同确认日起至乙方提出取消之日止；',
		'sign_contract.detail66': '赔偿金额：',
		'sign_contract.detail67': '按每日租金 × 已签约天数计算，最高不超过 1 个月租金。签约成功当天的后一个自然日开始计算赔偿。',
		'sign_contract.detail68': '补偿用于覆盖甲方因房源暂停出租产生的实际损失。',
        'sign_contract.detail68-1': '乙方因个人原因在入住日前取消签约，服务费不予退还。',
		'sign_contract.detail69': '甲方提前终止：',
		'sign_contract.detail70': '甲方提前终止的，应退还乙方所有未使用租金及押金。',
		'sign_contract.detail71': '如甲方无正当理由提前终止或取消预定，应向乙方支付补偿。若未另行约定，乙方最多可要求 1 个月租金作为补偿',
		'sign_contract.detail72': '因政府强制腾退或出现严重安全隐患等无法继续出租的，甲方可无责解除合同，但需提供相关证明，并退还乙方未使用款项。',
		'sign_contract.detail73': '第九条 不可抗力与政策变化',
		'sign_contract.detail74': '因自然灾害、疫情管控、政府政策调整等不可抗力事件导致无法继续履行合同的，双方应协商处理。平台不承担因此造成的损失。',
		'sign_contract.detail75': '第十条 争议与调解',
		'sign_contract.detail76': '争议应由双方先行在平台协商解决。',
		'sign_contract.detail77': '调解无果，任一方可向房屋所在地法院/仲裁机构申请处理。',
		'sign_contract.detail78': '第十一条 平台免责条款',
		'sign_contract.detail79': '平台角色：',
		'sign_contract.detail80': 'Wellcee（丙方）仅提供信息发布、线上签约及阶段性押金托管等技术服务，不参与租赁关系的成立、履行、变更或终止，也非合同当事人。',
		'sign_contract.detail81': '信息真实性责任：',
		'sign_contract.detail82': '房源信息、身份资料、证明文件及附件均由甲乙双方上传并确认，其真实性、合法性和完整性由上传方自行承担。平台不负实质审查义务，不保证房源可出租性、权属合法性或资料真实有效。',
		'sign_contract.detail83': '线下履约责任：',
		'sign_contract.detail84': '房屋交付、维修、水电物业结算、邻里纠纷等属双方线下履约范畴，由双方自行承担责任；平台不承担保证或连带责任。',
		'sign_contract.detail85': '押金争议边界：',
		'sign_contract.detail86': '平台对押金仅提供技术托管，不对扣除项目、损坏责任或费用合理性作判断。押金争议由双方协商解决；平台调解为协助性质，无强制力，调解失败应依法处理。',
		'sign_contract.detail87': '免责范围：',
		'sign_contract.detail88': '下列情形造成的损失、费用或纠纷，平台不承担责任',
		'sign_contract.detail89': '（1）用户提供虚假、不完整或失效资料；',
		'sign_contract.detail90': '（2）线下信息不一致或更新不及时；',
		'sign_contract.detail91': '（3）因网络、设备故障或不可抗力导致签约延迟或失败；',
		'sign_contract.detail92': '（4）任何间接损失、预期利益损失或惩罚性赔偿。',
		'sign_contract.detail93': '第十二条 信息保护',
		'sign_contract.detail94': '平台将对用户身份信息、人脸识别数据、聊天记录等隐私数据进行加密存储，仅用于租赁相关目的.',
		'sign_contract.detail95': '第十三条 合同生效',
		'sign_contract.detail96': '甲乙双方通过 Wellcee 平台进行确认即视为签署完成。本合同即时生效。',
		'sign_contract.detail97': '第十四条 合同语言',
		'sign_contract.detail98': '本合同包含中文和英文版本，两种语言版本均具有同等法律效力。如不同语言版本存在理解差异或冲突，以中文版本为准。',
		'sign_contract.detail99': '签署确认',
		'sign_contract.detail100': '甲方（出租方）：',
		'sign_contract.detail101': '乙方（承租方）：',
		'sign_contract.detail102': '丙方（Wellcee）：',
		'sign_contract.detail103': '签署日期：',
		'sign_contract.detail104': '上海良孝科技有限公司',
		'sign_contract.detail105': '补充协议',
		'sign_contract.detail106': '附件',
		'sign_contract.detail107': '房东实名信息',
		'sign_contract.detail108': '租客实名信息',
	},
	en: {
		// 页面分享
		让世界上每一个有可能的地方都变成家: "Create new ways of living and sharin life!",
		Wellcee的小伙伴们分享了好多有趣的故事和瞬间呢: "Our Wellcee friends shared so many nice moments and stories with you!",
		// 评论
		评论: "Comment",
		发表你的天才演讲: "Leave your genius comment here",
		作者: "Author",
		回复: "Reply",
		加载中: "Loading...",
		// lifestyle列表
		城市: "City",
		推荐: "Hot",
		不限: "Default",
		TA的房源: "Housing",
		TA的唯心市集: "Swap&Sale",
		TA的Lifestyle: "Lifestyle",
		TA的动态: "Dynamic",
		查看更多: "More",
		// 房源列表
		位置: "Location",
		租房类型: "Rent type",
		价格: "Price",
		区域: "District",
		租期: "Term",
		确定: "Confirm",
		最后登录: "Last login",
		全部: "All",
		// 房源详情
		详情: "Details",
		概况: "Overview",
		已出租: "Rented",
		租金: "Rent",
		月: "Month",
		类型: "Type",
		房间: "Room",
		卧室: "Bedroom",
		洗手间: "Bathroom",
		地铁: "Metro",
		押金: "Deposit",
		面积: "Room size",
		楼层: "Floor",
		描述: "Description",
		设施: "Facilities",
		地图: "Map",
		线上签约: "Apply",
		私信: "Chat",
		// 首页
		搜索房源: "Search Apt",
		即将开放: "Coming soon",
		唯心市集: "Swap&Sale",
		发现更多: "More",
		探索: "Discover",
		体验: "Explore",
		打开APP: "Open the APP",
		选择城市: "Select city",
		// 下载页
		一个有灵魂的租房平台: "A renting App with soul",
		无中介国际化社交: "direct rental｜international｜social",
		立即打开: "Open Immediately",
		立即下载: "Download Now",
		// 商务合作
		商务合作: "Business Cooperation",
		请选择: "Choose",
		合作类型: "Cooperation Type",
		姓名: "Name",
		你的称呼: "How would you like us to call you",
		联系方式: "Contact Number",
		手机号微信号: "Tel Number/Wechat",
		公司名称: "Company",
		请输入: "Please Enter Here",
		希望开展合作的城市: "Preferred Cities for Collaboration",
		备注: "Other",
		选填: "(Optional)",
		提交: "Submit",
		公寓商户: "Residence",
		优质民宿: "B&B",
		异业合作: "Co-branding",
		广告推广: "Ads Promotion",
		其他: "Other",
		公寓商户介绍: "Including service apts, residences, hotels, etc.",
		提交成功: "Submitted",
		请填写完整信息: "Please fill in all the required information",

		// 收不到验证码
		'no_auth_code.title': "Verification Code Problem",
		'no_auth_code.header': "If you cannot receive the verification code, please try the following actions:",
		'no_auth_code.step1': "Check and confirm if your phone number is deactivated or has no network.",
		'no_auth_code.step2': "Check if the verification code is being intercepted or moved to spam.",
		'no_auth_code.step3': "If you still cannot receive the code after these steps, please email us to ",
		'no_auth_code.step4': " with your personal information.",
		'no_auth_code.card.title': "Example:",
		'no_auth_code.card.item1': "Title: Unable to Receive Verification Code",
		'no_auth_code.card.item2': "Username: Max",
		'no_auth_code.card.item3': "Phone: +86 130****3465 (Add your country code)",
		'no_auth_code.card.item4': "Email: ",
		'no_auth_code.card.item5': "Gender: Female",
		'no_auth_code.footer': "After receiving your email, we will assist you in handling account-related issues.",

		// 手机号停机
		'phone_stop.title': "Number Deactivated",
		'phone_stop.header': "If your number is deactivated and you can't log in, please email us with your personal information at ",
		'phone_stop.card.title': "Example:",
		'phone_stop.card.item1': "Title: Unable to Log In – Phone Number Deactivated",
		'phone_stop.card.item2': "Username: Max",
		'phone_stop.card.item3': "Deactivated Number: +86 130****3465",
		'phone_stop.card.item4': "New Number: +86 183****1098",
		'phone_stop.card.item5': "City: Beijing",
		'phone_stop.footer': "After receiving your email, we will assist you in recovering your account.",

		// 优惠券规则
		'coupon_rule.title': 'Coupon Rules',

		// 线上签约合同详情页
		'sign_contract.detail1': 'Contract Confirmation',
		'sign_contract.detail2': 'Contract',
		'sign_contract.detail3': 'Note: Hidden information (real name, contact details marked with *) will be available after signing is completed',
		'sign_contract.detail4': 'Wellcee · Online Lease Agreement',
		'sign_contract.detail5': 'This Agreement is jointly confirmed and becomes effective among the following three parties:',
		'sign_contract.detail6': 'Lessor (Party A): ',
		'sign_contract.detail7': 'Lessee (Party B): ',
		'sign_contract.detail8': 'ID No.: ',
		'sign_contract.detail9': 'Contact: ',
		'sign_contract.detail10': 'Platform (Party C): Shanghai Liangxiao Technology Co., Ltd. (Wellcee)',
		'sign_contract.detail11': 'Party A and Party B have reached a leasing agreement via the Wellcee platform and voluntarily execute this Agreement electronically. Both parties acknowledge that online confirmation has the same legal effect as handwritten signatures or seals.',
		'sign_contract.detail12': 'Article 1: Property Information and Lease Term',
		'sign_contract.detail13': 'Property Address: ',
		'sign_contract.detail14': 'Lease Term: From ',
		'sign_contract.detail15': ' to ',
		'sign_contract.detail16': '.',
		'sign_contract.detail17': 'Article 2: Rent and Payment Terms',
		'sign_contract.detail18': 'he monthly rent is RMB ',
		'sign_contract.detail19': ' per month, excluding utilities, property management fees, and other miscellaneous charges.',
		'sign_contract.detail20': 'Rent shall be paid by the Lessee on a ',
		'sign_contract.detail21': 'monthly',
		'sign_contract.detail22': 'quarterly',
		'sign_contract.detail23': 'annual',
		'sign_contract.detail24': ' basis as agreed. Late payment may affect contract performance, with liability borne by the responsible party.',
		'sign_contract.detail25': 'Allocation of maintenance and other fees shall be subject to agreement between the Lessor and the Lessee.',
		'sign_contract.detail26': 'Article 3：Deposit Escrow Rules',
		'sign_contract.detail27': 'Deposit Escrow',
		'sign_contract.detail28': 'Upon signing, the Lessee shall pay a deposit of RMB ',
		'sign_contract.detail29': ', which will be held in staged technical escrow by the Wellcee platform. The platform provides escrow technology only and does not determine deposit liability.',
		'sign_contract.detail30': 'Deposit Withdrawal Timing',
		'sign_contract.detail31': 'After 15 days of occupancy, the Lessor may apply to withdraw the deposit. Within the first 15 days, the deposit serves as dispute security and may not be withdrawn without mutual confirmation.',
		'sign_contract.detail32': 'Supporting Evidence for Deposit Determination',
		'sign_contract.detail33': 'Deposit disputes arising within the first 15 days of occupancy shall be handled based on the following supporting materials: move-in property condition photos, supplemental agreements, platform chat records, and other relevant materials (missing or unclear materials may affect the platform’s coordination support)',
		'sign_contract.detail34': 'Dispute Resolution',
		'sign_contract.detail35': 'If the parties have any dispute regarding the deposit amount, the platform may assist in communication; however, the platform ',
		'sign_contract.detail36': ' does not make any determination regarding damage liability or the reasonableness of any deductions.',
		'sign_contract.detail37': 'If negotiation fails, either party may resolve the dispute through the court or arbitration institution at the location of the property.',
		'sign_contract.detail38': 'Article 4：Obligations of the Lessor',
		'sign_contract.detail39': 'The Lessor warrants lawful leasing rights and no risks of seizure, enforcement, or forced vacancy.',
		'sign_contract.detail40': 'The property condition shall match the listing; false descriptions entitle the Lessee to terminate with a full refund.',
		'sign_contract.detail41': 'Repairs due to normal wear or equipment defects shall be borne by the Lessor.',
		'sign_contract.detail42': 'The Lessor shall not reclaim the property early without just cause..',
		'sign_contract.detail43': 'The Lessor shall deliver the property in habitable condition at the time agreed by both parties.',
		'sign_contract.detail44': 'Article 5：Obligations of the Lessee',
		'sign_contract.detail45': 'The Lessee shall pay rent on time and use the property for normal residential purposes.',
		'sign_contract.detail46': 'Damage caused by the Lessee shall be repaired or compensated by the Lessee.',
		'sign_contract.detail47': 'No subleasing, group leasing, change of use, or storage of hazardous items without consent.',
		'sign_contract.detail48': 'Comply with property management rules and maintain civilized residency.',
		// 'sign_contract.detail49': '退租前需按平台要求上传完整退房照片。',
		'sign_contract.detail50': 'Article 6：Identity Verification and Risk Control',
		'sign_contract.detail51': 'Mainland users must complete facial recognition. Users from Hong Kong, Macao, Taiwan, or overseas must upload ID photos and selfie-with-ID photos.',
		'sign_contract.detail52': 'Submission of false information or identity misuse authorizes the platform to terminate the contract process, rendering the Agreement void, with consequences borne by the responsible party.',
		'sign_contract.detail53': 'Platform verification is technical only and does not constitute legal authentication.',
		'sign_contract.detail54': 'Article 7：Attachments and Supplemental Agreements',
		'sign_contract.detail55': 'The Lessor may upload attachments including supplemental agreements, property condition photos, furniture lists, handover checklists, and move-in instructions.',
		'sign_contract.detail56': 'All attachments form an integral part of this Agreement with equal legal effect.',
		'sign_contract.detail57': 'In case of conflict, the latest mutually confirmed attachment shall prevail.',
		'sign_contract.detail58': 'Article 8：Early Termination',
		'sign_contract.detail59': 'Early Termination by the Lessee:',
		'sign_contract.detail60': 'If the Lessee terminates the lease early, the Lessee shall notify the Lessor at least 30 days in advance.',
		'sign_contract.detail61': 'Unless otherwise specially agreed by both parties, in the event of early termination by the Lessee, the Lessor may require the Lessee to pay compensation not exceeding one (1) month’s rent.',
		'sign_contract.detail62': 'If the Lessee is unable to occupy the property due to property quality issues, safety hazards, inconsistency with the listing, or the Lessor’s failure to deliver a habitable property as agreed, the Lessee may terminate this Agreement without liability, and the Lessor shall refund all amounts paid by the Lessee.',
		'sign_contract.detail63': 'If the Lessee cancels a confirmed order before the move-in date for personal reasons, such cancellation shall constitute a unilateral breach. The Lessor may charge a “Compensation Fee”, calculated as follows:',
		// 'sign_contract.detail64': 'Lock-in period: ',
		// 'sign_contract.detail65': 'from the date of contract confirmation to the date on which the Lessee submits the cancellation;',
		'sign_contract.detail66': 'Compensation amount: ',
		'sign_contract.detail67': `Daily rent multiplied by the number of days contracted, capped at one month's rent. The compensation period begins on the day after the contract is successfully signed.`,
		'sign_contract.detail68': 'The compensation is intended to cover the Lessor’s actual losses arising from the suspension of leasing the property.',
		'sign_contract.detail68-1': 'If the Lessee cancels the contract prior to the check-in date for personal reasons, the service fee shall be non-refundable.',
        'sign_contract.detail69': 'Early Termination by the Lessor:',
		'sign_contract.detail70': 'If the Lessor terminates this Agreement early, the Lessor shall refund the Lessee all unused rent and the deposit.',
		'sign_contract.detail71': 'If the Lessor terminates the Agreement or cancels the reservation without just cause, the Lessor shall compensate the Lessee. Unless otherwise agreed, the Lessee may claim compensation of up to one (1) month’s rent.',
		'sign_contract.detail72': 'If the lease cannot continue due to government-mandated eviction or serious safety hazards, the Lessor may terminate this Agreement without liability, provided that relevant proof is furnished and all unused amounts are refunded to the Lessee.',
		'sign_contract.detail73': 'Article 9：Force Majeure and Policy Changes',
		'sign_contract.detail74': 'If this Agreement cannot continue to be performed due to force majeure events such as natural disasters, epidemic control measures, or government policy adjustments, the parties shall resolve the matter through mutual consultation. The platform shall not be liable for any losses arising therefrom.',
		'sign_contract.detail75': 'Article 10：Dispute Resolution and Mediation',
		'sign_contract.detail76': 'Any dispute shall first be resolved through negotiation between the parties on the platform.',
		'sign_contract.detail77': 'If mediation fails, either party may apply for resolution before the court or an arbitration institution at the location of the property.',
		'sign_contract.detail78': 'Article 11：Platform Disclaimer',
		'sign_contract.detail79': 'Platform Role:',
		'sign_contract.detail80': 'Wellcee (Party C) provides technical services only, including information listing, online contract execution, and staged deposit escrow. It does not participate in the formation, performance, modification, or termination of the lease relationship and is not a contracting party to this Agreement.',
		'sign_contract.detail81': 'Responsibility for Information Authenticity: ',
		'sign_contract.detail82': 'All property information, identity data, supporting documents, and attachments are uploaded and confirmed by Party A and Party B. The uploading party shall bear sole responsibility for the authenticity, legality, and completeness of such information. The platform has no obligation to conduct substantive review and does not guarantee the leasability of the property, the legality of ownership, or the authenticity and validity of the information.',
		'sign_contract.detail83': 'Offline Performance Responsibilities:',
		'sign_contract.detail84': 'Matters including property delivery, repairs, settlement of utilities and property management fees, and neighborhood disputes fall within the scope of offline performance between the parties and shall be borne by the parties themselves; the platform shall not assume any guarantee liability or joint and several liability.',
		'sign_contract.detail85': 'Scope of Deposit Disputes:',
		'sign_contract.detail86': 'The platform provides technical escrow services for the deposit only and does not make any determination regarding deduction items, damage liability, or the reasonableness of any fees. Deposit disputes shall be resolved through negotiation between the parties; any mediation provided by the platform is assistive in nature and non-binding, and disputes not resolved through mediation shall be handled in accordance with the law.',
		'sign_contract.detail87': 'Scope of Disclaimer: ',
		'sign_contract.detail88': 'The platform shall not be liable for any losses, costs, or disputes arising from the following circumstances',
		'sign_contract.detail89': '(1) users providing false, incomplete, or invalid information;',
		'sign_contract.detail90': '(2) inconsistency of offline information or untimely updates thereof;',
		'sign_contract.detail91': '(3) delays or failures in contract execution caused by network issues, device malfunctions, or force majeure events;',
		'sign_contract.detail92': '(4) any indirect losses, loss of expected benefits, or punitive damages.',
		'sign_contract.detail93': 'Article 12：Information Protection',
		'sign_contract.detail94': 'The platform shall store users’ identity information, facial recognition data, chat records, and other personal data in encrypted form, and such data shall be used solely for purposes related to the leasing transaction.',
		'sign_contract.detail95': 'Article 13：Effectiveness',
		'sign_contract.detail96': 'This Agreement shall be deemed executed upon confirmation by both Party A and Party B via the Wellcee platform and shall take effect immediately.',
		'sign_contract.detail97': 'Article 14：Language',
		'sign_contract.detail98': 'This Agreement is executed in both Chinese and English, and both language versions shall have equal legal effect. In the event of any discrepancy or inconsistency in interpretation between the two versions, the Chinese version shall prevail.',
		'sign_contract.detail99': 'Signatures',
		'sign_contract.detail100': 'Party A (Lessor): ',
		'sign_contract.detail101': 'Party B (Lessee): ',
		'sign_contract.detail102': 'Party C (Wellcee): ',
		'sign_contract.detail103': 'Date: ',
		'sign_contract.detail104': 'Shanghai Liangxiao Technology Co., Ltd.',
		'sign_contract.detail105': 'Additional Terms',
		'sign_contract.detail106': 'Attachments',
		'sign_contract.detail107': 'Landlord Identity Information',
		'sign_contract.detail108': 'Tenant Identity Information',
	},
	tw: {
		// 页面分享
		让世界上每一个有可能的地方都变成家: "讓世界上每一個有可能的地方都變成家！",
		Wellcee的小伙伴们分享了好多有趣的故事和瞬间呢: "Wellcee的小伙伴們分享了好多有趣的故事和瞬間呢！",
		// 评论
		评论: "評論",
		发表你的天才演讲: "發表你的天才演講",
		作者: "作者",
		回复: "回複",
		加载中: "加載中...",
		推荐: "推薦",
		不限: "不限",
		TA的房源: "TA的房源",
		TA的唯心市集: "TA的唯心市集",
		TA的Lifestyle: "TA的Lifestyle",
		TA的动态: "TA的動態",
		查看更多: "查看更多",
		// 房源列表
		位置: "位置",
		租房类型: "租房類型",
		价格: "價格",
		区域: "區域",
		租期: "租期",
		确定: "確定",
		最后登录: "最後登錄",
		全部: "全部",
		// 房源详情
		详情: "詳情",
		概况: "概況",
		已出租: "已出租",
		租金: "租金",
		月: "月",
		类型: "類型",
		房间: "房間",
		卧室: "臥室",
		洗手间: "洗手間",
		地铁: "地鐵",
		押金: "押金",
		面积: "面積",
		楼层: "樓層",
		描述: "描述",
		设施: "設施",
		地图: "地圖",
		线上签约: "線上簽約",
		私信: "私信",
		// 首页
		搜索房源: "搜索房源",
		即将开放: "即將開放",
		唯心市集: "唯心市集",
		发现更多: "發現更多",
		探索: "探索",
		体验: "體驗",
		打开APP: "打開APP",
		选择城市: "選擇城市",
		// 下载页
		一个有灵魂的租房平台: "一個有靈魂的租房平台",
		无中介国际化社交: "無中介｜國際化｜社交",
		立即打开: "立即打開",
		立即下载: "立即下載",

		// 商务合作
		商务合作: "商務合作",
		请选择: "請選擇",
		合作类型: "合作類型",
		姓名: "姓名",
		你的称呼: "你的稱呼",
		联系方式: "聯絡方式",
		手机号微信号: "手機號碼/微信號",
		公司名称: "公司",
		请输入: "請輸入",
		城市: "城市",
		希望开展合作的城市: "希望開展合作的城市",
		备注: "其他",
		选填: "（選填）",
		提交: "提交",
		公寓商户: "公寓商戶",
		优质民宿: "優質民宿",
		异业合作: "異業合作",
		广告推广: "廣告推廣",
		其他: "其他",
		公寓商户介绍: "包含公寓、二房東、包租公司、城中村大業主等",
		提交成功: "提交成功",
		请填写完整信息: "請填寫完整信息",

		// 收不到验证码
		'no_auth_code.title': "收不到驗證碼",
		'no_auth_code.header': "如果您的手機無法正常獲取驗證碼，建議您進行以下操作：",
		'no_auth_code.step1': "檢查並確認您的手機號是否停機/無網絡。",
		'no_auth_code.step2': "檢查您的驗證碼是否被攔截/移至垃圾箱。",
		'no_auth_code.step3': "如進行以上操作後仍無法收到驗證碼，請發郵件聯繫我們：",
		'no_auth_code.step4': " 並附上您的個人信息。",
		'no_auth_code.card.title': "示例：",
		'no_auth_code.card.item1': "標題: 手機號無法接收驗證碼",
		'no_auth_code.card.item2': "帳戶暱稱: Max",
		'no_auth_code.card.item3': "手機號: +86 130****3465（添加您的國家區號）",
		'no_auth_code.card.item4': "郵箱: ",
		'no_auth_code.card.item5': "性別: 女",
		'no_auth_code.footer': "收到您的郵件後，我們會協助您處理帳號相關問題。",

		// 手机号停机
		'phone_stop.title': "手機號停機",
		'phone_stop.header': "如果您的手機號已停機，無法登錄賬號，請通過郵箱聯繫我們並附上個人信息：",
		'phone_stop.card.title': "示例：",
		'phone_stop.card.item1': "標題: 手機號停機無法登錄",
		'phone_stop.card.item2': "帳戶暱稱: Max",
		'phone_stop.card.item3': "帳戶綁定的手機號: +86 130****3465",
		'phone_stop.card.item4': "新手機號: +86 183****1098",
		'phone_stop.card.item5': "城市: 北京",
		'phone_stop.footer': "收到您的郵件後，我們會協助您找回賬號。",

		// 优惠券规则
		'coupon_rule.title': '優惠券通用規則',

		// 线上签约合同详情页
		'sign_contract.detail1': '合同确认',
		'sign_contract.detail2': '查看合同',
		'sign_contract.detail3': '提示：签约完成后可查看隐藏信息（实名、联系方式等带*的信息）',
		'sign_contract.detail4': 'Wellcee · 线上租赁合同',
		'sign_contract.detail5': '本合同由以下三方共同确认生效：',
		'sign_contract.detail6': '出租方（甲方）：',
		'sign_contract.detail7': '承租方（乙方）：',
		'sign_contract.detail8': '证件号：',
		'sign_contract.detail9': '联系方式：',
		'sign_contract.detail10': '平台方（丙方）：上海良孝科技有限公司（Wellcee）',
		'sign_contract.detail11': '甲方与乙方通过 Wellcee 平台达成租赁意向，并自愿采用线上方式签署本合同。双方确认：本合同经线上确认后，与线下手写签名或盖章具备同等法律效力。',
		'sign_contract.detail12': '第一条 房屋信息与租赁期限',
		'sign_contract.detail13': '房屋详细地址：',
		'sign_contract.detail14': '租赁期限：自',
		'sign_contract.detail15': ' 起至 ',
		'sign_contract.detail16': ' 止。',
		'sign_contract.detail17': '第二条 租金与支付方式',
		'sign_contract.detail18': '双方确认 月租金为人民币 ',
		'sign_contract.detail19': ' 元/月（不含水电气费、物业费及其他杂费）。',
		'sign_contract.detail20': '租金由乙方根据事先和房东的约定按 ',
		'sign_contract.detail21': '月度',
		'sign_contract.detail22': '季度',
		'sign_contract.detail23': '年度',
		'sign_contract.detail24': ' 支付。逾期可能影响合同继续履行，由责任方承担后果。',
		'sign_contract.detail25': '维修费、物业费及其他费用的承担方式，以甲、乙双方协议为准。',
		'sign_contract.detail26': '第三条 押金托管规则',
		'sign_contract.detail27': '押金托管',
		'sign_contract.detail28': '乙方签约时需支付押金人民币 ',
		'sign_contract.detail29': ' 元，由 Wellcee 平台进行阶段性托管；平台仅提供技术托管，不承担押金责任认定。',
		'sign_contract.detail30': '押金可提现时间',
		'sign_contract.detail31': '乙方入住满 15 天后，甲方可在平台申请提取押金。入住 15 天内押金作为纠纷保障，未经双方确认不予提前提取。',
		'sign_contract.detail32': '押金依据资料',
		'sign_contract.detail33': '入住 15 天内的押金纠纷，以以下资料为依据：入住时的房屋现状照片、补充协议、平台聊天记录等（资料缺失或模糊，将影响相关协调支持。）',
		'sign_contract.detail34': '争议处理',
		'sign_contract.detail35': '若双方对押金金额有异议，平台可协助沟通，但平台',
		'sign_contract.detail36': '不对损坏责任或扣款合理性作出判断；',
		'sign_contract.detail37': '协商不成的，双方可通过房屋所在地法院或仲裁机构解决。',
		'sign_contract.detail38': '第四条 甲方（出租方）义务',
		'sign_contract.detail39': '保证房屋具备合法出租权，不存在查封、抵押、腾退风险。',
		'sign_contract.detail40': '保证房屋状况与租房信息一致；如存在虚假描述，乙方可解除合同，甲方需退还所有费用。',
		'sign_contract.detail41': '自然损耗或设备质量问题由甲方负责维修。',
		'sign_contract.detail42': '不得在租期内无正当理由提前收回房屋.',
		'sign_contract.detail43': '需按约定时间交付可正常居住的房屋。',
		'sign_contract.detail44': '第五条 乙方（承租方）义务',
		'sign_contract.detail45': '按时支付租金，遵守正常居住使用范围。',
		'sign_contract.detail46': '因乙方人为原因导致的设施损坏，需承担维修或赔偿费用。',
		'sign_contract.detail47': '不得擅自转租、群租、改变房屋用途或存放危险品。',
		'sign_contract.detail48': '需遵守小区物业管理规定，文明居住.',
		'sign_contract.detail49': '退租前需按平台要求上传完整退房照片。',
		'sign_contract.detail50': '第六条 身份验证与风控要求',
		'sign_contract.detail51': '大陆用户需完成人脸识别；港澳台及外国用户需上传证件照及手持证件照。',
		'sign_contract.detail52': '若任一方提交虚假资料、冒用他人身份，平台有权终止合同流程，合同自动失效，由责任方承担全部后果。',
		'sign_contract.detail53': '平台进行的是 技术性校验，不构成对身份真实性的法律鉴定。',
		'sign_contract.detail54': '第七条 合同附件与补充协议',
		'sign_contract.detail55': '房源出租方（甲方）可上传的附件，包括但不限于：补充协议、房屋现状照片、家具电器清单、交割清单、入住须知等。',
		'sign_contract.detail56': '所有上传附件均视为本合同组成部分，与本合同具有同等效力。',
		'sign_contract.detail57': '若附件内容与主合同冲突，以双方确认的最新附件为准。',
		'sign_contract.detail58': '第八条 提前终止合同',
		'sign_contract.detail59': '乙方提前退租：',
		'sign_contract.detail60': '乙方提前退租应至少提前 30 日通知甲方。',
		'sign_contract.detail61': '若双方无特别约定，乙方提前退租，甲方可要求乙方支付 不超过 1 个月租金 的补偿。',
		'sign_contract.detail62': '若因房屋质量问题、安全隐患、房源不符、甲方未按约交付可居住房屋等原因导致乙方无法入住，乙方可无责解除合同，甲方应退还乙方已支付的全部款项。',
		'sign_contract.detail63': '乙方因个人原因在入住日前取消已确认订单的，视为单方违约。甲方可向乙方收取"违约金"，其计算方式为：',
		// 'sign_contract.detail64': '锁房天数：',
		// 'sign_contract.detail65': '自合同确认日起至乙方提出取消之日止；',
		'sign_contract.detail66': '赔偿金额：',
		'sign_contract.detail67': '按每日租金 × 已签约天数计算，最高不超过 1 个月租金。签约成功当天的后一个自然日开始计算赔偿。',
		'sign_contract.detail68': '补偿用于覆盖甲方因房源暂停出租产生的实际损失。',
		'sign_contract.detail68-1': '乙方因个人原因在入住日前取消签约，服务费不予退还。',
		'sign_contract.detail69': '甲方提前终止：',
		'sign_contract.detail70': '甲方提前终止的，应退还乙方所有未使用租金及押金。',
		'sign_contract.detail71': '如甲方无正当理由提前终止或取消预定，应向乙方支付补偿。若未另行约定，乙方最多可要求 1 个月租金作为补偿',
		'sign_contract.detail72': '因政府强制腾退或出现严重安全隐患等无法继续出租的，甲方可无责解除合同，但需提供相关证明，并退还乙方未使用款项。',
		'sign_contract.detail73': '第九条 不可抗力与政策变化',
		'sign_contract.detail74': '因自然灾害、疫情管控、政府政策调整等不可抗力事件导致无法继续履行合同的，双方应协商处理。平台不承担因此造成的损失。',
		'sign_contract.detail75': '第十条 争议与调解',
		'sign_contract.detail76': '争议应由双方先行在平台协商解决。',
		'sign_contract.detail77': '调解无果，任一方可向房屋所在地法院/仲裁机构申请处理。',
		'sign_contract.detail78': '第十一条 平台免责条款',
		'sign_contract.detail79': '平台角色',
		'sign_contract.detail80': 'Wellcee（丙方）仅提供信息发布、线上签约及阶段性押金托管等技术服务，不参与租赁关系的成立、履行、变更或终止，也非合同当事人。',
		'sign_contract.detail81': '信息真实性责任',
		'sign_contract.detail82': '房源信息、身份资料、证明文件及附件均由甲乙双方上传并确认，其真实性、合法性和完整性由上传方自行承担。平台不负实质审查义务，不保证房源可出租性、权属合法性或资料真实有效。',
		'sign_contract.detail83': '线下履约责任',
        'sign_contract.detail84': '房屋交付、维修、水电物业结算、邻里纠纷等属双方线下履约范畴，由双方自行承担责任；平台不承担保证或连带责任。',
		'sign_contract.detail85': '押金争议边界：',
		'sign_contract.detail86': '平台对押金仅提供技术托管，不对扣除项目、损坏责任或费用合理性作判断。押金争议由双方协商解决；平台调解为协助性质，无强制力，调解失败应依法处理。',
		'sign_contract.detail87': '免责范围：',
		'sign_contract.detail88': '下列情形造成的损失、费用或纠纷，平台不承担责任：',
		'sign_contract.detail89': '（1）用户提供虚假、不完整或失效资料；',
		'sign_contract.detail90': '（2）线下信息不一致或更新不及时；',
		'sign_contract.detail91': '（3）因网络、设备故障或不可抗力导致签约延迟或失败；',
		'sign_contract.detail92': '（4）任何间接损失、预期利益损失或惩罚性赔偿。',
		'sign_contract.detail93': '第十二条 信息保护',
		'sign_contract.detail94': '平台将对用户身份信息、人脸识别数据、聊天记录等隐私数据进行加密存储，仅用于租赁相关目的。',
		'sign_contract.detail95': '第十三条 合同生效',
		'sign_contract.detail96': '甲乙双方通过 Wellcee 平台进行确认即视为签署完成。本合同即时生效。',
		'sign_contract.detail97': '第十四条 合同语言',
		'sign_contract.detail98': '本合同包含中文和英文版本，两种语言版本均具有同等法律效力。如不同语言版本存在理解差异或冲突，以中文版本为准。',
		'sign_contract.detail99': '签署确认',
		'sign_contract.detail100': '甲方（出租方）：',
		'sign_contract.detail101': '乙方（承租方）：',
		'sign_contract.detail102': '丙方（Wellcee）：',
		'sign_contract.detail103': '签署日期：',
		'sign_contract.detail104': '上海良孝科技有限公司',
		'sign_contract.detail105': '补充协议',
		'sign_contract.detail106': '附件',
		'sign_contract.detail107': '房东实名信息',
		'sign_contract.detail108': '租客实名信息',
	},
};

